export default __webpack_public_path__ + "static/AGaramondPro-Regular-28a8104789b0dc0d6c002d9e65d1500f.otf";